import {NinchatState} from 'api/types'
import {createSelector} from '@reduxjs/toolkit'

type GetGroupQueuesArgs = [
    NinchatState['user_queues'],
    NinchatState['_queues'],
    boolean,
    string,
]

export const getGroupQueues = createSelector(
    [
        (state: {ninchat: NinchatState}) => state.ninchat.user_queues,
        (state: {ninchat: NinchatState}) => state.ninchat._queues,
        (_state: {ninchat: NinchatState}, isGroupQueue: boolean) => isGroupQueue,
        (_state: {ninchat: NinchatState}, _isGroupQueue: boolean, queue_id: string) => queue_id,
    ],
    (...[
        user_queues,
        _queues,
        isGroupQueue,
        queue_id,
    ]: GetGroupQueuesArgs) => {
        const queues = {
            ..._queues || {},
            ...user_queues || {},
        }

        if (isGroupQueue) {
            return Object.entries(queues)
                .filter(([, queue]) => queue.queue_attrs?.group_id === queue_id)
                .map(([id, details]) => ({
                    id,
                    queueProps: details,
                }))
        }
        return []
    },
)
